import { Fragment } from "react";
import Navbar from "../../components/Navbar";

import ProjectMenuItems from "../../components/ProjectMenuItems";
import Footer from "../../components/footer";
import Scrollbar from "../../components/scrollbar";
import Logo from "../../images/logo.png";
import ProyectTitle from "../../components/ProyectTitle";

import blogs from '../../api/blogs';
import proyects from "../../api/projects-cluster";

const ProjectMenu = () => {
   

    const BlogDetails = proyects[0];
  return (
    <Fragment>
      <Navbar Logo={Logo} />
       <ProyectTitle pageTitle={BlogDetails.title} bgClass={BlogDetails.bgClass} pagesub={BlogDetails.title}/> 
      <ProjectMenuItems />
      <Scrollbar />
      <Footer />
    </Fragment>
  );
};
export default ProjectMenu;
